import React, {
  useEffect, useRef, useState, useCallback
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import Tiles from '@components/Tiles';
import cn from 'classnames';
import styles from './index.module.scss';
import { setNotification } from '@reducers/notification';
import { checkOpen, callServer } from '@reducers/checks';
import { openEmployeeCheck, logout, setOpen } from '@reducers/oauth';
import { LABEL } from '../../veriables';
import {
  APP_CONFIG,
} from '@constants';
import {
  setSeat, clearCart, setCurrentPage,
  removePosition, pushCartItems, enableStartOverBtn,
  setCategoryHeight, getOrderMenus
} from '@reducers/orders';
import { landingPageTile } from '@reducers/kiosk';
import { getObjectValue, convertDateToString } from '@utility/helperFunction';
import { flowType } from '@utility/userInfo';
import EventEmitter from '@utility/eventSubscribers';
import { COUNTRY_CODE } from '@constants/index';

const KioskLandingPage = (props) => {

  // Props Destructuring

  const {auth, kioskTile, setOpen, getOrderMenus, deviceInfo, checkOpen, setSeat, setNotification, enableStartOverBtn, landingPageTile, setCategoryHeight,
  userInfo, logout, openEmployeeCheck, isHeight, isEmployeeCheck,  } = props;

  // State Management
  const defaultCountryCode = getObjectValue(() => COUNTRY_CODE[auth.country].dialCode, '1');

  const [countryCode] = useState(defaultCountryCode);
  const themeProperties = JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const tileImage = getObjectValue(() => kioskTile.filter((e) => e.tileTarget.homePage), []);

  // Methods

  const itemsFilter = (array) => {
    return array.filter((e) => e.pending).map((e) => {
      return {
        ...e,
        ...JSON.parse(e.orderJson)
      };
    });
  };

  const returnCloseTime = () => {
    const currentDate = new Date();
    const timeDiffArray = auth.menuSchedules && auth.menuSchedules.length > 0 && auth.menuSchedules.reduce((a, b) => {
      a.push({
        ...b,
        difference: +(Math.abs(moment(convertDateToString(b.endTime)).diff(moment(currentDate), 'seconds', true))).toFixed(2)
      });
      return a;
    }, []).sort((a, b) => b.difference - a.difference);
    return auth.menuSchedules && auth.menuSchedules.length > 0 ? getObjectValue(() => timeDiffArray[timeDiffArray.length - 1].endTime, '00:00:00') : '00:00:00';
  };

  const storeClose = (schedule) => {
    let returnVal = false;
    const currentDate = new Date();
    const timeDiffArray = auth.menuSchedules && auth.menuSchedules.length > 0 && auth.menuSchedules.reduce((a, b) => {
      a.push({
        ...b,
        difference: +(Math.abs(moment(convertDateToString(b.startTime)).diff(moment(currentDate), 'seconds', true))).toFixed(2)
      });
      return a;
    }, []).sort((a, b) => b.difference - a.difference);
    const closeTime = convertDateToString(schedule && schedule.length > 0 ? schedule[0].endTime : returnCloseTime());
    const eodTime = convertDateToString(auth && auth.eodTime);
    const startTime = schedule && schedule.length > 0 ? convertDateToString(schedule[0].startTime) : convertDateToString(timeDiffArray[timeDiffArray.length - 1].startTime);
    if (startTime <= currentDate && closeTime >= eodTime && currentDate <= closeTime) {
      returnVal = true;
    } else if (startTime <= currentDate && closeTime < eodTime && currentDate <= closeTime.setDate(closeTime.getDate() + 1)) {
      returnVal = true;
    }
    return returnVal;
  };

  const getCurrentTime = () => {
    const currentDate = new Date();
    const schedule = getObjectValue(() => auth.menuSchedules.filter((e) => convertDateToString(e.startTime) <= currentDate && currentDate <= convertDateToString(e.endTime)), []);
    return auth.eodTime && auth.eodTime.trim().split('0').length !== 7 ? storeClose(schedule) : (schedule.length > 0 || false);
  };

  const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    const intervalId = useRef(null);
    const [close, setClose] = useState(callback() || false);
    const clear = useCallback(() => clearInterval(intervalId.current), []);

    savedCallback.current = callback;

    // Set up the interval.
    useEffect(() => {
      const tick = () => {
        setClose(savedCallback.current());
      };
      if (delay) {
        intervalId.current = setInterval(tick, delay);
      }
      return () => clear();
    }, [delay]);
    return close;
  };

  useEffect(() => {
    setOpen(false);
  }, []);

  const openCheck = () => {
    getOrderMenus(getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).id, 0));
    window.sessionStorage.removeItem('screenId');
    const toGoValue = getObjectValue(() => deviceInfo.deviceGroup.orderTypes.toGo);
    if (deviceInfo.deviceGroup !== null) {
      if (getObjectValue(() => deviceInfo.deviceGroup.orderTypes, false) && getObjectValue(() => deviceInfo.deviceGroup.orderTypes.dineIn, false) && getObjectValue(() => deviceInfo.deviceGroup.orderTypes.toGo, false)) {
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/kioskOrder`);
      } else if (deviceInfo.deviceGroup.inputFields.nameEnabled === true || deviceInfo.deviceGroup.inputFields.phoneNumberEnabled === true) {
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
      } else {
        const dataToSend = {
          deviceId: deviceInfo.deviceId,
          employeeId: Number(JSON.parse(window.sessionStorage.getItem('userInfo')).id),
          storeId: deviceInfo.storeId,
          phoneNumber: '',
          countryCode,
          stationId: null,
          toGo: toGoValue,
          employeeCard: null,
          name: '',
          stationGroupId: null,
          isTab: true,
          pickupTime: null,
          guestName: null,
          guestCount: 1,
          sourceType: 1,
          delivery: false,
          speedOrder: false,
        };
        checkOpen(dataToSend).then((val) => {
          setSeat({ ...val, pendingItems: itemsFilter((val.orders[0].items) || []) });
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/orders`);
        }).catch((err) => {
          setNotification({
            type: 'danger',
            message: err.message
          });
        });
      }
    } else {
      const dataToSend = {
        deviceId: deviceInfo.deviceId,
        employeeId: Number(JSON.parse(window.sessionStorage.getItem('userInfo')).id),
        storeId: deviceInfo.storeId,
        phoneNumber: '',
        countryCode,
        stationId: null,
        toGo: false,
        employeeCard: null,
        name: '',
        stationGroupId: null,
        isTab: true,
        pickupTime: null,
        guestName: null,
        guestCount: 1,
        sourceType: 1,
        delivery: false,
        speedOrder: false,
      };
      checkOpen(dataToSend).then((val) => {
        setSeat({ ...val, pendingItems: itemsFilter((val.orders[0].items) || []) });
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/orders`);
      }).catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    }
  };

  const returnStartOver = () => {
    if (auth.menuSchedules.length === 0) {
      return true;
    }
    if (auth.menuSchedules.find((e) => e.allDay)) {
      return auth.menuSchedules.find((e) => e.allDay).allDay;
    }
    return useInterval(() => { const result = getCurrentTime(); return result; }, 1000);
  };
  
  const closeStore = returnStartOver();

  useEffect(() => {
    enableStartOverBtn(false);
    setCategoryHeight(false);
    landingPageTile(deviceInfo.storeId);
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
      EventEmitter.getViewHeight((data) => {
        if (data.height !== 100) {
          EventEmitter.postSetViewHeight(100);
        }
      });
    }
  }, []);

  const handleClick = (type) => {
  };

  const signOut = () => {
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => userInfo.id, JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      employeeCard: getObjectValue(() => userInfo.employeeCard, null)
    };
    logout(dataToSend);
    props.history.replace('/checkIn');
  };

  const handleTouchStart = () => {
    openEmployeeCheck();
  };

  // HTML CSS Code

  return (
    <div className="col-12 p-0 h-100 w-100">
      <div
        className="col-3 p-0 text-right position-absolute"
        onTouchStart={handleTouchStart}
        style={{
          right: '5px',
          zIndex: '999',
          widht: '50px',
          height: '50px'
        }}
      />
      {!isHeight && (
        <>
          <div className="col-12 h-50 p-0 text-center" style={{overflow:'hidden'}}>
            <img
              src={themeProperties.kioskHeroImageUrl}
              alt=""
              className={`d-block mx-auto w-100 h-100`}
              onError={(e) => { e.target.style.visibilty = 'hidden'; }}
              style={{objectFit: 'contain'}}
            />
          </div>
          <div className="h-35 d-flex px-0 py-1 align-items-start">
            <div className="col-12 text-center h-100 p-0">
              <div className="row px-1 h-100">
                <Tiles
                  carouselData={getObjectValue(() => tileImage.filter((e, i) => i === 0 && e.imageUrls.length > 0 && e, []))}
                  data={getObjectValue(() => tileImage.filter((e, i) => i === 0 && e.imageUrls.length > 0 && e).length === 0, true) && getObjectValue(() => tileImage.filter((e, i) => i === 0 && e), [])}
                  onClick={handleClick}
                />
              </div>
            </div>
          </div>
        </>
      )}
      {closeStore ? (
        <div className={cn('row col-12 align-items-end justify-content-center pt-2 px-4 mx-0', !isHeight ? 'h-15' : 'h-100')}>
          <button
            type="button"
            className="btn btn100 rounded od-btn-primary btn-primary btn-ripple my-1 w-70"
            onClick={() => openCheck()}
            style={{ zIndex: '500' }}
          >
            <div className="fs-30">{LABEL().KIOSK_START_ORDER}</div>
          </button>
        </div>
      ) : (
        <div className={cn('col-12 h-15 p-0 text-center', !isHeight ? 'h-20' : 'h-100')}>
          <img
            src={themeProperties.kioskClosedImageUrl}
            alt=""
            className={`img-fluid w-100 d-block mx-auto ${styles.maxHeight}`}
            onError={(e) => { e.target.style.visibilty = 'hidden'; }}
          />
        </div>
      )}
      {isEmployeeCheck && <EmployeeCheck {...props} caseType={flowType()} callBack={() => signOut()} customClass2={['kiosk'].includes(flowType()) ? styles.maxWidth : ''} />}
    </div>
  );
};

// Redux Part

const mapStateToProps = ({
  oauth,
  orders,
  kiosk
}) => ({
  loading: oauth.loading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  isEmployeeCheck: oauth.isEmployeeCheck,
  userInfo: oauth.loggedInUserData,
  kioskTile: kiosk.kioskTile,
  deviceTypeId: oauth.deviceTypeId,
  isHeight: orders.isHeight
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  setSeat,
  checkOpen,
  clearCart,
  openEmployeeCheck,
  setCurrentPage,
  removePosition,
  pushCartItems,
  landingPageTile,
  enableStartOverBtn,
  logout,
  getOrderMenus,
  callServer,
  setCategoryHeight,
  setOpen
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KioskLandingPage);
